import axios from "axios";
import { logout } from "../lib/auth";

import { dataDifine, EditDataDifine } from "../config/dataInterface";
import { CONST } from "../config/const";
import { makeParams } from "./common";

// フォローコール設定 - エントリーパートナー一覧取得
export async function getFollowCallConfigEntrySaleCompanys(id: string) {
  try {
    const path = "followCallConfigEntrySaleCompanys";
    const params = { id };
    const response = await axios.get(CONST.apiUrl + path, {
      params,
    });
    if (response.data.fetch_data === "null") {
      return { sudDatas: [] };
    }
    return {
      sudDatas: response.data.fetch_data,
      entrySaleCompanyData: response.data.entry_sale_company_data,
    };
  } catch (error) {
    return { sudDatas: [] };
    // logout();
  }
}

// フォローコール設定 - エントリーパートナー一覧登録
export async function postFollowCallConfigEntrySaleCompanys(addData: {
  [key: string]: string | boolean | any[];
}) {
  try {
    const path = "followCallConfigEntrySaleCompanys";
    const bodys = { addData };
    const response = await axios.post(CONST.apiUrl + path, {
      bodys,
    });
    return response.data.add;
  } catch (error) {
    // logout();
  }
}
